import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiErrorCodes, ErrorCodes } from '../../../../core/enums/ErrorCodes';
import { IPagedResults } from '../../../../core/interfaces/IPagedResults';
import { IPagination } from '../../../../core/interfaces/IPagination';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { ApiService } from '../../../../core/services/ApiService';
import { GuidUtils } from '../../../../core/utils/GuidUtils';
import { ICart } from '../../../cart/core/interfaces/ICart';
import { CartService } from '../../../cart/core/services/CartService';
import { OnlineOrderStatuses } from '../enums/OnlineOrderStatuses';
import { IOnlineOrder } from '../interfaces/IOnlineOrder';
import { IOnlineOrderDetails } from '../interfaces/IOnlineOrderDetails';

@Injectable({
  providedIn: 'root'
})
export class OnlineOrdersService {

  private readonly _basePath = '/online-orders';
  private readonly _apiService = inject(ApiService);
  private readonly _cartService = inject(CartService);

  public static isErrorResponse(res: IResponse<unknown>): boolean {
    return !!res?.message && (res.message in ApiErrorCodes || res.message in ErrorCodes);
  }

  public getOnlineOrders(
    status: OnlineOrderStatuses,
    pagination: IPagination,
    search?: string
  ): Observable<IResponse<IPagedResults<IOnlineOrder>>> {
    let httpParams = new HttpParams()
      .append('status', status)
      .append('page', pagination.page)
      .append('results', pagination.results);

    if (search?.trim()) {
      httpParams = httpParams.append('search', search.trim());
    }

    return this._apiService.get(this._basePath, httpParams);
  }

  public getOnlineOrder(transactionId: number): Observable<IResponse<IOnlineOrderDetails>> {
    return this._apiService.get(`${this._basePath}/${transactionId}`);
  }

  public fulfilPosition(transactionId: number, payVoucherId: number, code: string): Observable<IResponse<ICart>> {
    return this._apiService.post(
      `${this._basePath}/${transactionId}/positions/${payVoucherId}/fulfil`,
      {
        code,
        operationId: GuidUtils.raw()
      }
    ).pipe(
      tap((res: IResponse<ICart>) => {
        if (res?.data) {
          this._cartService.triggerCartAction(res.data, 'addItem');
        }
      })
    );
  }
}
